// extracted by mini-css-extract-plugin
export default {"plans":"product-rules_plans__tzi3a","skeletonWrapper":"product-rules_skeletonWrapper__i8LFX","ruleSlot":"product-rules_ruleSlot__vbJTr"};